module.exports = __webpack_public_path__ + "media/images/icon_copy-0c9cb7947c789ba6965328bb1e93ad1c.png";